<template>
  <div class="pt-1 schedule-levels-container" id="cards-info">
    <div
      v-for="(level, index) in groupByLevels"
      :key="`level${index}`"
      class="lvl-box"
    >
      <div class="lvl-header bg-pacific-blue">{{ index + 1 }}º nível</div>
      <section
        class="group-box"
        v-for="group in level"
        :key="`group${group.index}`"
        :ref="`group${group.index}`"
      >
        <div :id="`action${schedule}idx${group.index}`" class="confirm-fade">
          <h6 v-show="action == 'delete'">
            Deseja realmente excluir este grupo de válvulas?<br />
          </h6>
          <h6 v-show="action == 'edit'">
            Aviso: Este nível contém subníveis de ferti.<br />
          </h6>
          <b-btn
            @click="confirmDeleteGroup(group.index)"
            v-show="action == 'delete'"
            variant="danger"
            size="sm"
          >
            Excluir
          </b-btn>
          <b-btn
            @click="confirmEdit(group.index, true, `group${group.index}`)"
            v-show="action == 'edit'"
            variant="danger"
            size="sm"
          >
            Continuar
          </b-btn>
          <b-btn @click="cancel(group.index, action)" size="sm">
            Cancelar
          </b-btn>
        </div>
        <section class="center-xs valves">
          {{ `${group.COUNT} válvula(s)` }}
        </section>
        <section class="valve-box">
          <span
            v-for="valve in group.ELEMENTS"
            :key="valve.NAME"
            class="container-header"
          >
            <div>{{ valve.NAME }}</div>
            <b-badge
              v-if="valve.MIN_FLOW === null || valve.MAX_FLOW === null"
              class="bg-black"
            >
              Vazão média desconhecida
            </b-badge>
            <b-badge v-else-if="valve.AREA" class="bg-info">
              {{ calcWaterDepth(group.duration.TIME, valve) }}
            </b-badge>
            <!-- <br /> -->
          </span>
        </section>
        <div class="prevision" v-if="agnStart">
          <strong>Horário:</strong>
          {{ `${calcDuration(index, group.duration.TIME)}` }}<br />
        </div>
        <section class="group-info">
          <strong>Duração:</strong> {{ group.duration.TIME }} min<br />
          <!-- <span v-if="group.ELEMENTS.length && group.ELEMENTS[0].HAS_MANAGEMENT"> -->
          <!-- <span>
            <strong> 
              Ajuste sugerido:
            </strong>
            <span>

              {{ lam2Min(group)}} min<br />
            </span>
          </span> -->
          <!-- <span
            :class="
              group.duration.MIN_TIME && group.duration.MIN_TIME > 0
                ? ''
                : 'no-property'
            "
          >
            <strong>Mínimo:</strong> {{ group.duration.MIN_TIME }} min<br />
          </span>
          <span
            :class="
              group.duration.ADVANCE_TIME && group.duration.ADVANCE_TIME > 0
                ? ''
                : 'no-property'
            "
          >
            <strong>Avanço:</strong> {{ group.duration.ADVANCE_TIME }} min<br />
          </span> -->
          <!-- </section>
        <section class="group-info"> -->
          <span v-if="group.duration.VOLUME">
            <strong>Volume de corte:</strong>
            {{ group.duration.VOLUME }} L<br />
          </span>
          <span v-if="group.duration.VOLUME === 0">
            <strong>Volume previsto:</strong>
            {{ previewVolume(group, flows) }} m³
          </span>

        </section>
        <div class="row around-xs level-btns" v-if="editmode">

          <b-btn
            variant="light"
            size="sm"
            title="Duplicar Nível"
            @click="duplicateGroup(group.index)"
          >
            <content-copy title="Duplicar Nível" />
          </b-btn>
          <b-btn
            class="btn-delete"
            size="sm"
            @click="deleteGroup(group.index)"
            title="Deletar nível"
          >
            <delete-icon title="Deletar nível" />
          </b-btn>
          <b-btn
            variant="3v3"
            size="sm"
            @click="
              editGroup(group.index, group.FERTI.length, `group${group.index}`)
            "
            title="Editar nível"
          >
            <pencil-icon title="Editar nível" />
          </b-btn>
          <b-btn
            variant="sea-blue"
            size="sm"
            v-if="group.COUNT == 1"
            :ref="`ferti${group.index}`"
            title="Editar ferti"
            @click="
              addFertiLevel(
                group.index,
                group.ELEMENTS[0],
                `group${group.index}`
              )
            "
          >
            <beaker-icon title="Editar ferti" />
          </b-btn>
        </div>
        <div v-if="group.FERTI.length" class="ferti-title">
          <beaker-icon title="" style="vertical-align: -1px" /> SUBNÍVEIS DE
          FERTI
        </div>
        <section v-for="(ferti, index) in group.FERTI" :key="ferti.FERTILEVEL">
          <div class="ferti-item row">
            <div :class="editmode ? 'col-xs-9' : 'col-xs-11'">
              <div class="bg-ferti">
                {{ ferti.FERTILEVEL }}º {{ ferti.ELEMENTS[0].NAME }}
              </div>
              <div class="container-group-info">
                <div class="group-info">
                  <strong>Duração:</strong> {{ ferti.duration.TIME }}
                </div>
                <div class="group-info">
                  <span
                    :class="
                      ferti.duration.VOLUME && ferti.duration.VOLUME > 0
                        ? ''
                        : 'no-property'
                    "
                  >
                    <strong>Volume:</strong> {{ ferti.duration.VOLUME }} L
                  </span>
                </div>
              </div>
            </div>
            <div class="col-xs-3" v-if="editmode">
              <b-btn
                @click="removeFertiLevel(group.index, ferti.FERTILEVEL, index)"
                size="sm"
                class="btn-delete"
              >
                <delete-icon title="" />
              </b-btn>

              <b-btn
                @click="
                  editFertiLevel(
                    group.index,
                    ferti.FERTILEVEL,
                    group.ELEMENTS[0],
                    `group${group.index}`
                  )
                "
                size="sm"
                title="Editar ferti"
                variant="3v3"
              >
                <pencil-icon title="" />
              </b-btn>
            </div>
          </div>
        </section>
      </section>
    </div>
  </div>
</template>

<script>
import { avgVolume, getValvesTotalDurationByLevels } from "../helpers";

export default {
  name: "scheduleLevels",
  props: {
    levels: Array,
    editmode: Boolean,
    schedule: String,
    agnStart: String,
    whereToScroll: String,
    showForm: Boolean,
    flows: Object,
    hectare: Number,
  },
  created() {
    if (this.levels && this.levels.length) this.organizeByLevel(this.levels);
    this.repairFertiLevelHoles(this.levels);
  },
  data() {
    return {
      name: "",
      groupByLevels: [],
      action: null,
    };
  },
  updated() {
    if (
      this.whereToScroll &&
      this.$refs[this.whereToScroll] &&
      this.$refs[this.whereToScroll][0]
    ) {
      this.$refs[this.whereToScroll][0].scrollIntoView({ block: "center" });
      return;
    }
    if (!this.showForm && this.action === null) {
      let lastElement = Array.from(
        document.querySelectorAll("#cards-info > .lvl-box")
      );
      lastElement[lastElement.length - 1].scrollIntoView(true);
    }
  },
  watch: {
    levels(value) {
      this.organizeByLevel(this.levels);
    },
    totalDurationByValve(newValue) {
      this.$emit("update-total-duration-by-valve", newValue);
    },
    groupByLevels(newV, oldV) {
      if (newV.length !== oldV.length) {
        this.action = null;
      }
    },
    showForm(newVal, oldVal) {
      if (!!oldVal && !newVal) {
        if (
          this.whereToScroll &&
          this.$refs[this.whereToScroll] &&
          this.$refs[this.whereToScroll][0]
        ) {
          this.$refs[this.whereToScroll][0].scrollIntoView({ block: "center" });
        }
      }
    },
  },
  computed: {
    totalDurationByValve() {
      const levelsMapped = this.groupByLevels.map((level) => level[0]);
      return this.getValvesTotalDurationByLevels(levelsMapped);
    },
  },
  methods: {
    repairFertiLevelHoles(levels) {
      levels.map((level) =>
        level.FERTI.map((level, i) => (level.FERTILEVEL = i + 1))
      );
    },
    avgVolume,
    getValvesTotalDurationByLevels,
    previewVolume(group, flows) {
      if (
        group.ELEMENTS &&
        group.ELEMENTS[0] &&
        group.ELEMENTS[0].management_infos &&
        group.ELEMENTS[0].management_infos.filter((m) => m).length
      ) {
        return group.elements[0].management_infos.TOTAL_VOLUME_CURRENT;
      } else {
        return this.avgVolume(group, flows);
      }
    },
    calcWaterDepth(DURATION, VALVE) {
      DURATION = Number(DURATION);
      let { ID, AREA, MIN_FLOW, MAX_FLOW } = VALVE;
      // DURATION em min, AREA em hA, MAX E MIN FLOW em m³/h
      let hours = DURATION / 60; //em h
      // avgFlow //em m³/h
      let avgFlow = this.flows[ID] || (MAX_FLOW + MIN_FLOW) / 2;
      let volPerHour = avgFlow * hours; //em m³
      let areaInMeters = AREA * this.hectare; //em m²
      let waterDepth = volPerHour / areaInMeters; //em m
      return (waterDepth * 1000).toFixed(2) + "mm"; //em mm
    },
    parseToMin(time) {
      time = time.split(":");
      let hour = Number(time[0]);
      let minute = Number(time[1]);
      hour = hour * 60;
      return hour + minute;
    },
    parseToHHmm(min) {
      let hours = Math.floor(min / 60);
      let minutes = min % 60;
      if (hours >= 24) hours = hours % 24;
      hours = (hours < 10 ? "0" : "") + hours;
      minutes = (minutes < 10 ? "0" : "") + minutes;
      let result = hours + ":" + minutes;
      return result;
    },
    calcDuration(level, duration) {
      let prevision = this.parseToMin(this.agnStart);
      duration = Number(duration);
      for (let i = 0; i < this.groupByLevels.length; i++) {
        if (i == level) break;
        else {
          prevision += Math.max(
            ...this.groupByLevels[i].map((e) => Number(e.duration.TIME))
          );
        }
      }
      return `${this.parseToHHmm(prevision)} - ${this.parseToHHmm(
        prevision + duration
      )}`;
    },
    addFertiLevel(groupIndex, element, div) {
      this.action = "add-ferti";
      this.$emit("ferti-add", groupIndex, element, div);
    },
    editFertiLevel(levelIndex, fertilevel, element, div) {
      let params = {
        levelIndex,
        fertilevel,
      };
      this.$emit("ferti-edit", params, element, div);
    },
    removeFertiLevel(groupIndex, fertilevel, fertiindex) {
      this.action = "remove-ferti";
      let newLevels = this.levels;
      newLevels[groupIndex].FERTI.splice(fertiindex, 1);
      newLevels[groupIndex].FERTI.map((ferti) => {
        if (ferti.FERTILEVEL > fertilevel) ferti.FERTILEVEL--;
      });
      if (this.editmode) this.$emit("ferti-remove", newLevels);
    },
    editGroup(groupIndex, ferti, div) {
      this.action = "edit";
      if (ferti) {
        document.getElementById(
          "action" + this.schedule + "idx" + groupIndex
        ).style.display = "block";
      } else this.$emit("level-edit", groupIndex, false, div);
    },
    deleteGroup(groupIndex) {
      this.action = "delete";
      document.getElementById(
        "action" + this.schedule + "idx" + groupIndex
      ).style.display = "block";
    },
    duplicateGroup(groupIndex) {
      // this.action = "duplicate";
      this.$emit("duplicate", groupIndex);
    },
    confirmDeleteGroup(groupIndex) {
      let newLevels = this.levels.length ? this.levels.map((e) => e) : [];
      let levelOfRemoved = this.levels[groupIndex].LEVEL; //save the level of the item removed
      newLevels.splice(groupIndex, 1); //remove the group
      let groupsRemainedInLevel = newLevels.length
        ? !!newLevels.filter((e) => e.LEVEL == levelOfRemoved).length
        : false;
      for (let i = 0; i < newLevels.length; i++) {
        if (!groupsRemainedInLevel && newLevels[i].LEVEL > levelOfRemoved) {
          newLevels[i].LEVEL = newLevels[i].LEVEL - 1;
        }
        if (newLevels[i].LEVEL < newLevels[i].GROUP) {
          newLevels[i].GROUP = newLevels[i].GROUP - 1;
        }
        //sweep the rest of items
        if (newLevels[i].FERTI.length) {
          newLevels[i].FERTI = newLevels[i].FERTI.map((e) => {
            e.LEVEL = newLevels[i].LEVEL;
            return e;
          });
        }
        if (newLevels[i].ELEMENTS.length) {
          newLevels[i].ELEMENTS = newLevels[i].ELEMENTS.map((e) => {
            e.LEVEL = newLevels[i].LEVEL;
            return e;
          });
        }
      }
      if (this.editmode) this.$emit("level-remove", newLevels);
      this.closeActionWarning(groupIndex);
    },
    closeActionWarning(groupIndex) {
      this.action = "";
      document.getElementById(
        "action" + this.schedule + "idx" + groupIndex
      ).style.display = "none";
    },
    confirmEdit(groupIndex, hasFerti, div) {
      if (this.action == "edit") {
        this.$emit("level-edit", groupIndex, hasFerti, div);
      }
      this.closeActionWarning(groupIndex);
    },
    cancel(groupIndex, action) {
      this.closeActionWarning(groupIndex);
    },
    organizeByLevel(sublevels) {
      /* função que transforma os níveis em arrays de subníveis para iteração com v-for */
      if (sublevels.constructor != Object || Object.keys(sublevels).length) {
        if (sublevels.length) {
          let lenOfLevels = Math.max(...sublevels.map((a) => a.LEVEL));
          sublevels = sublevels.map((e, i) => {
            e.index = i;
            return e;
          });
          let byLevels = [];
          for (let i = 1; i <= lenOfLevels; i++) {
            byLevels.push(sublevels.filter((lvl) => lvl.LEVEL == i));
          }
          byLevels = byLevels.filter((e) => e.length != 0);
          this.groupByLevels = byLevels;
          if (this.editmode) this.$emit("set-level", this.groupByLevels.length);
        } else {
          this.groupByLevels = [];
          if (this.editmode) this.$emit("set-level", this.groupByLevels.length);
        }
      }
    },
  },
};
</script>

<style scoped>
.badge {
  font-size: 0.65em !important;
  padding: 5px;
  font-weight: 500;
}

.bg-ferti {
  background-color: #298abe;
  border-radius: 4px;
  font-size: 1.1em;
  color: #fff;
  padding: 2px 8px;
}
.valves {
  font-weight: 600;
  font-size: 1.2em;
  color: #6d6d6d;
}
.lvl-box {
  width: 100%;
  color: #666;
  font-size: 0.7em;
  padding-bottom: 5px;
  margin-bottom: 6px;
  background-color: white;
  border-radius: 4px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
}
.lvl-box .lvl-header {
  margin-bottom: 0;
  width: 100%;
  color: #fff;
  text-align: center;
  font-weight: 600;
  font-size: 1.8em;
  border-radius: 4px 4px 0 0;
}
.group-box {
  position: relative;
  background-color: #fff;
  margin: 5px 2%;
  width: 96%;
  padding: 2px 5px 0 5px;
}
.group-box .material-design-icon {
  font-size: 1rem;
}
.confirm-fade {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  padding: 36px 0;
  width: 100%;
  height: 100%;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 10;
}
.confirm-fade .btn {
  margin: 0px 20px;
  width: 110px;
}
.container-group-info {
  padding-left: 9px;
}
.valve-box {
  font-size: 1.4em;
  color: #17a2b8;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  margin-bottom: 2px;
  margin: 0 1%;
}
.valve-box .container-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.valve-box .container-header div {
  font-weight: 700;
  color: #6d6d6d;
}
.lvl-box .prevision {
  width: 98%;
  margin: 0 1%;
}
.group-info {
  margin: 0 1%;
  display: inline-block;
  /* width: 46%; */
  width: 60%;
}
.group-info,
.prevision {
  font-size: 1.2em;
}
.no-property {
  opacity: 0.25;
  text-decoration: line-through;
}
.lvl-box div.level-btns {
  margin-top: 5px;
  margin-left: 0px;
  margin-right: 0px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.lvl-box div.level-btns .btn {
  padding: 2px 5px;
}
.ferti-title {
  margin-top: 5px;
  margin-bottom: 5px;
  font-weight: 700;
  color: #6d6d6d;
  font-size: 1.2em;
}
.ferti-item {
  margin-left: 0;
  margin-bottom: 15px;
}
.ferti-item h6 {
  margin-bottom: 2px;
  color: #fff;
  font-size: 1.2em;
  padding: 2px 8px;
}
.ferti-item .btn {
  padding: 1px 3px;
  margin-bottom: 3px;
}
.material-design-icon {
  font-size: 1.4em;
}
@media (max-width: 767px) {
  #form,
  #details {
    padding-top: 0.5em;
  }
}
</style>
